import { CANCELLATION_REASONS } from '../../global.constants';
import type { CancellationReason } from '../../global.types';

export const ACCOUNT_SELECTION_VIEW_NAME = 'Account selection view';

export const ACCOUNT_SELECTION_VIEW_CANCELLATION_REASONS = [
  CANCELLATION_REASONS.myAccountIsNotDisplayed,
  CANCELLATION_REASONS.wantToPayAnotherWay,
  CANCELLATION_REASONS.other,
] satisfies CancellationReason[];
